import { useCallback } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import Button from './Button';
import { Deactivation } from './Deactivation';

export default function ButtonContent() {
  const {
    font,
    contentAboveButton,
    contentBelowButton,
    contentAboveButtonFont,
    contentBelowButtonFont,
    positionType,
    contentAboveButtonColor,
    contentBelowButtonColor
  } = useSettings();

  const renderButtonContent = useCallback(() => {
    if (positionType === 'floating') {
      return <Button />;
    }

    return (
      <Deactivation>
        <Container>
          {contentAboveButton && (
            <ContentAboveButton
              style={{
                ...contentAboveButtonFont,
                color: contentAboveButtonColor,
                fontFamily: font.value
              }}
              dangerouslySetInnerHTML={{ __html: contentAboveButton }}
            />
          )}
          <Button />

          {contentBelowButton && (
            <ContentBelowButton
              style={{
                ...contentBelowButtonFont,
                color: contentBelowButtonColor,
                fontFamily: font.value
              }}
              dangerouslySetInnerHTML={{ __html: contentBelowButton }}
            />
          )}
        </Container>
      </Deactivation>
    );
  }, [
    contentAboveButton,
    contentAboveButtonFont,
    contentAboveButtonColor,
    font,
    positionType,
    contentBelowButton,
    contentBelowButtonFont,
    contentBelowButtonColor
  ]);

  return renderButtonContent();
}

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const ContentAboveButton = styled.div`
  margin-bottom: 16px;
  text-align: center;
  & p {
    margin: 0;
  }
`;
const ContentBelowButton = styled.div`
  margin-top: 16px;
  text-align: center;

  & p {
    margin: 0;
  }
`;
